<template>
  <div>
    <b-form @submit="register">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Nombre *" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="formData.names"
              type="text"
              required
              placeholder="Ingrese el nombre del cliente"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Apellido Paterno *" label-for="input-3">
            <b-form-input
              id="input-3"
              v-model="formData.lastName"
              type="text"
              required
              placeholder="Ingrese el apellido pat."
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Apellido Materno *" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="formData.motherLastName"
              type="text"
              required
              placeholder="Ingrese el apellido mat."
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            id="input-group-4"
            label="Tipo de documento *"
            label-for="input-4"
          >
            <b-form-select
              id="input-4"
              v-model="formData.dadDocumentType"
              :options="optionsDoc"
              required
            >
              <template #first>
                <b-form-select-option :value="null" disabled
                  >Seleccione uno</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            id="input-group-5"
            label="N° de documento *"
            label-for="input-5"
          >
            <b-form-input
              id="input-5"
              :value="documentClient"
              v-on:input="$emit('update:documentClient', $event)"
              type="text"
              required
              placeholder="Ejm. 75212392"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Teléfono *" label-for="input-6">
            <b-form-input
              id="input-6"
              v-model="formData.phones[0].contact"
              type="text"
              required
              placeholder="Ejm. 999777999"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Correo electrónico *" label-for="input-7">
            <b-form-input
              id="input-7"
              @keyup="validateEmail"
              v-model="formData.mails[0].contact"
              type="email"
              required
              placeholder="Ejm. franco.paredes@promart.pe"
            ></b-form-input>
          </b-form-group>
          <p>{{ msg }}</p>
        </b-col>
      </b-row>
      <!--<b-row>
        <b-col cols="12">
          <b-form-group label="Dirección *" label-for="input-8">
            <b-form-input
              id="input-8"
              v-model="formData.directions[0].street"
              type="text"
              required
              placeholder="Ingrese la dirección actual del cliente"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col cols="12">
          <b-form-group
            id="input-group-9"
            label="Departamento *"
            label-for="input-9"
          >
            <b-form-select
              id="input-9"
              v-model="selectedDep"
              @change="getProvince"
              required
            >
              <option :value="null">Seleccione el Departamento</option>

              <option
                v-for="departament in deparments"
                :value="departament"
                :key="departament.id"
              >
                {{ departament.text }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group
            id="input-group-10"
            label="Provincia *"
            label-for="input-10"
          >
            <b-form-select
              id="input-10"
              v-model="selectedProvince"
              @change="getDistrict"
              required
            >
              <option :value="null">Seleccione la provincia</option>

              <option
                v-for="province in provinces"
                :value="province"
                :key="province.id"
              >
                {{ province.text }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Distrito *" label-for="input-11">
            <b-form-select
              required
              id="input-11"
              v-model="selectedDistr"
              size="md"
            >
              <template #first>
                <b-form-select-option :value="null" disabled
                  >Seleccione el distrito</b-form-select-option
                >
              </template>
              <option
                v-for="district in districts"
                :value="district"
                :key="district.id"
              >
                {{ district.text }}
              </option>
            </b-form-select>
          </b-form-group>
          <!-- <b-form-group label="Distrito *" label-for="input-11">
            <b-form-select v-model="selectedDistr" required id="input-11">
              <option :value="null">Seleccione el distrito</option>
              <option
                v-for="district in districts"
                :value="district"
                :key="district.id"
              >
                {{ district.text }}
              </option>
            </b-form-select>
          </b-form-group> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            id="input-group-4"
            label="Tipo de Vivienda *"
            label-for="input-4"
          >
            <b-form-select
              id="input-4"
              v-model="formData.directions[0].typeHousing"
              :options="optionsType"
              required
            > 
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" md="6">
          <b-form-group label="Dirección *" label-for="input-17">
            <b-form-input
              id="input-17"
              v-model="formData.directions[0].street"
              type="text"
              required
              placeholder="Ingrese la calle"
            ></b-form-input>
          </b-form-group>
        </b-col>
        
      </b-row>
      <b-row>
        <b-col cols="4" md="4">
          <b-form-group label="Dep./Int./Lt." label-for="input-120">
            <b-form-input
              id="input-120"
              v-model="formData.directions[0].numDepartament"
              type="text"
              required
              
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4" md="4">
          <b-form-group label="Nro./Mz./Bloq.*" label-for="input-18">
            <b-form-input
              id="input-18"
              v-model.number="formData.directions[0].number"
              type="text"
              required
              placeholder="Ingrese el número"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4" md="4">
          <b-form-group label="Piso *" label-for="input-18">
            <b-form-input
              id="input-18"
              v-model.number="formData.directions[0].numFloor"
              type="text"
              required
              placeholder="Ingrese el número"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Referencia *" label-for="input-12">
            <b-form-input
              id="input-12"
              v-model="formData.directions[0].reference"
              type="text"
              required
              placeholder="Ejm. Altura del paradero de la línea 190"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-center">
          <b-button class="bg-orange" type="submit">Registrar cliente</b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import {createLogs} from '../../assets/js/common'
import { mapState } from "vuex";
export default {
  name: "RegisterClient",
  data() {
    return {
      msg: "",
      optionsType:["Casa / Departamento","Oficina","Otros"],
      optionsDoc: ["DNI", "RUC"],
      deparments: [],
      districts: [],
      provinces: [],
      selectedDep: null,
      selectedDistr: null,
      selectedProvince: null,
      formData: {
        phones: [
          {
            active: true,
            contact: "",
            contactType: "PHONE",
            description: "Numero del contacto",
            priority: 5,
          },
        ],
        mails: [
          {
            active: true,
            contact: "",
            contactType: "EMAIL",
            description: "Email del contacto",

            priority: 105,
          },
        ],
        directions: [
          {
            dateLastSO: moment().format("YYYY-MM-DD"),
            department: "",
            district: "",
            number: 0,
            priority: 105,
            province: "",
            reference: "",
            street: "",
            ubigeo: "",
            typeHousing:"Casa / Departamento",
            numFloor:1
          },
        ],
        identityDocument: "",
        lastName: "",
        motherLastName: "",
        names: "",
        dadDocumentType: null,
      },
    };
  },
  computed:{
    ...mapState("module", [    
      "username",
      "token"
    ]),
  },
  props: {
    documentClient: {
      type: String,
    },
  },
  created() {
    this.getDepartments();
  },
  methods: {
    validateEmail() {
      const mailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!mailRegex.test(this.formData.mails[0].contact)) {
        this.msg = "Ingrese un email válido";
      } else {
        this.msg = "";
      }
    },
    async getDepartments() {
      try {
        // this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_LOCALIZATION_BASE + "/departments?limit=50&page=1",
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.deparments = data;
//        this.$bvModal.show("modal-register-client");
      } catch (error) {
        console.log(error);
      } finally {
        // this.$store.commit("SET_LOADING", false)
      }
    },
    async register() {
      event.preventDefault();
      try {
        this.$store.commit("SET_LOADING", true);
        this.formData.directions[0].province = this.selectedProvince.text;
        this.formData.directions[0].department = this.selectedDep.text;
        this.formData.directions[0].district = this.selectedDistr.text;
        this.formData.directions[0].ubigeo = this.selectedDistr.value;
        this.formData.identityDocument = this.documentClient;
        let response = await axios.post(
          process.env.VUE_APP_CLIENT_CORE_BASE + "/clients",
          this.formData,
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );

        createLogs(response.config.url,this.username,response.config.method,this.$router.history.current.path);
        let val = {
          show: true,
          //  document: this.formData.identityDocument,
          data: response.data,
        };
        this.$emit("setShow", val);
        this.$bvModal.hide("modal-register-client");
      } catch (error) {
        createLogs(error.response.config.url,this.username,error.response.config.method,this.$router.history.current.path);
        if (error.response) {
          let values = {
            variant: "danger",
            msg: error.response.data.message,
          };

          this.$store.commit("SET_ERROR_MSG", values);
          this.$store.commit("setShowAlert", true);
        }

        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
    async getProvince(e) {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_LOCALIZATION_BASE +
            "/departments/" +
            e.value +
            "/provinces",
            {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );

        //this.$store.dispatch('SET_SKUCOMPROBANTE',response.data)
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.provinces = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async getDistrict(e) {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_LOCALIZATION_BASE +
            "/provinces/" +
            e.value +
            "/districts",
            {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );

        const data = response.data.map((row) => {
          return {
            value: row.ubigeo,
            text: row.description,
          };
        });
        this.districts = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
};
</script>

